module.exports = __webpack_public_path__ + "static/media/teaching_bg_icon.c72003a0.png";